const displaynextatd = (state = [], action) => {
    switch (action.type) {
      case 'GROUP_VISIBLE':
      return {
          type: "GROUP_VISIBLE",
          displaynextgroup: action.displaynextgroup,
          displaynextgrouptemp: action.displaynextgrouptemp,
        }
      default:
        return state
    }
  }
  
  export default displaynextatd